import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as Rx from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { AppSettingService } from '../app.service';
import { UserInfoService } from '../user/user-info.service';


@Injectable({
	providedIn: 'root'
})
export class CommentAPIService {
	CommentGroupchanged: any = null;
	commentPostIDsToHighlight: any = []; //needed by comments page for highlighting unread comments: navigation.component is only place responsbile for setting/clearing this value.

	constructor(
		private userInfo: UserInfoService,
		private http: HttpClient
	) {
		this.CommentGroupchanged = new Rx.BehaviorSubject(1);
	}

	private url = AppSettingService.appConfig.JourneyAPIUrl + "Comment";

	getCommentTopic(commentKey: string): Rx.Observable<boolean> {
		return this.http.get<any>(
			this.url + "/Topic/" + commentKey,
			{
				withCredentials: true,
				headers: { 'Authorization': this.userInfo.authHeader(false) }
			}
		);
	}

	checkCommentLikeExist(commentKey: string): Rx.Observable<boolean> {
		return this.http.get<any>(
			this.url + "/Topic/" + commentKey + "/Like/exist",
			{
				withCredentials: true,
				headers: { 'Authorization': this.userInfo.authHeader(false) }
			}
		).pipe(map(
			response => {
				return (response.Detail.toLowerCase() === "true") ? true : false
			}
		));
	}

	updateCommentLike(commentKey: string, action: "add" | "delete"): Rx.Observable<any> {
		return this.http.get<any>(
			this.url + "/Topic/" + commentKey + "/Like/" + action,
			{
				withCredentials: true,
				headers: { 'Authorization': this.userInfo.authHeader(false) }
			}
		);
	}

	checkCommentPersonExist(commentKey: string): Rx.Observable<boolean> {
		return this.http.get<any>(
			this.url + "/Topic/" + commentKey + "/Group/exist",
			{
				withCredentials: true,
				headers: { 'Authorization': this.userInfo.authHeader(false) }
			}
		).pipe(map(
			response => {
				return (response.Detail.toLowerCase() === "true") ? true : false
			}
		));
	}

	updateCommentPerson(commentKey: string, action: "add" | "delete"): Rx.Observable<any> {
		return this.http.get<any>(
			this.url + "/Topic/" + commentKey + "/Group/" + action,
			{
				withCredentials: true,
				headers: { 'Authorization': this.userInfo.authHeader(false) }
			}
		).pipe(tap(x => {
			this.CommentGroupchanged.next(this.CommentGroupchanged.getValue() + 1);
		}));
	}

	saveCommentPost(commentKey: string, comment: string, forCommentPostId?: number): Rx.Observable<any> {
		let data = {
			"Comment": comment,
			"ForCommentPostId": forCommentPostId
		}
		return this.http.post<any>(
			this.url + "/Topic/" + commentKey + "/Post",
			data,
			{
				withCredentials: true,
				headers: { 'Authorization': this.userInfo.authHeader(false) }
			}
		);
	}

	searchCommentPosts(commentKey: string, startCommentPostId: string,limit: number): Rx.Observable<any> {	
		return this.http.get<any>(
			this.url + "/Topic/" + commentKey + "/Post?startCommentPostId=" + startCommentPostId + "&limit=" + limit.toString(),
			{
				withCredentials: true,
				headers: { 'Authorization': this.userInfo.authHeader(false) }
			}
		);
	}

	getCommentPost(commentKey: string, commentPostId: number): Rx.Observable<any> {
		return this.http.get<any>(
			this.url + "/Topic/" + commentKey + "/Post/" + commentPostId.toString(),
			{
				withCredentials: true,
				headers: { 'Authorization': this.userInfo.authHeader(false) }
			}
		);
	}

	checkCommentPostLikeExist(commentPostId: number): Rx.Observable<boolean> {
		return this.http.get<any>(
			this.url + "/Post/" + commentPostId.toString() + "/Like/exist",
			{
				withCredentials: true,
				headers: { 'Authorization': this.userInfo.authHeader(false) }
			}
		).pipe(map(
			response => {
				return (response.Detail.toLowerCase() === "true") ? true : false
			}
		));
	}

	updateCommentPostLike(commentPostId: number, like: "add" | "delete"): Rx.Observable<any> {
		return this.http.get<any>(
			this.url + "/Post/" + commentPostId.toString() + "/Like/" + like,
			{
				withCredentials: true,
				headers: { 'Authorization': this.userInfo.authHeader(false) }
			}
		);
	}
}
